const getFileName = (src) => {
  return src.split('/').pop()
}

const getImageName = (src) => {
  return getFileName(src).replace(/.mp4|.m4v|.webm/gi, '.jpg')
}

export { getFileName, getImageName }
